@if (tabLinks) {
  <dv-tabs [tabLinks]="tabLinks" />
}
<router-outlet />
